import type { FC } from "react";
import { useEffect } from "react";
import { parseChartData } from "./parseChartData";
import { NoData } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";
import ChartView from "pro-features/components/Chart/src/Chart";
import { useOverlapOvertimeContext } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/context";
import type { IData } from "app/pages/website-analysis/audience-overlap/SharedVisitorsTable/sharedTypes";
import { chartTypes } from "app/UtilitiesAndConstants/Constants/ChartTypes";
import { getChartConfig } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/chartConfig";
import type { ISiteLegendItems } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelAnalysisChart/ChannelAnalysisChartContainer";
import styled from "styled-components";

const Container = styled.div`
    width: 100%;
    overflow: hidden;
    .highcharts-container,
    .highcharts-container svg {
        /* this was added so that the graph width will be 100% of the container regardless to any resize event */
        width: 100% !important;
    }
`;

export const Chart: FC<{ rawData: IData; chosenSitesLegends: ISiteLegendItems }> = ({
    rawData,
    chosenSitesLegends,
}) => {
    const overlapOvertimeContext = useOverlapOvertimeContext();
    const { selectedMetric, chartDataAll, setChartDataAll } = overlapOvertimeContext;
    useEffect(() => {
        const chartDataAll = parseChartData(overlapOvertimeContext, rawData, chosenSitesLegends);
        setChartDataAll(chartDataAll);
    }, [rawData, selectedMetric]);
    const chartData = chartDataAll?.[selectedMetric];
    const chartConfig = getChartConfig(overlapOvertimeContext);
    const isNoData = !chartData || chartData.length === 0;
    return isNoData ? (
        <NoData
            paddingTop="10px"
            noDataTitleKey="global.nodata.notavilable"
            noDataSubTitleKey="workspaces.marketing.nodata.subtitle"
        />
    ) : (
        <Container>
            <ChartView
                type={chartTypes.LINE}
                data={chartData}
                config={chartConfig}
            />
        </Container>
    );
};
